import React from "react"
import { Container, Row, Col } from "reactstrap"
import HeroBgVector from "../../images/hero-bg-vector.svg"
import "./MykaV2Hero.scss"

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.848L0 24l6.308-1.506A11.946 11.946 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.938a9.907 9.907 0 01-5.081-1.396l-.364-.217-3.781.991.999-3.67-.238-.378A9.908 9.908 0 012.063 12C2.063 6.534 6.534 2.063 12 2.063S21.938 6.534 21.938 12 17.466 21.938 12 21.938z" />
  </svg>
)

const HeroBodyContent = ({
  intro,
  linkLabel,
  whatsappUrl,
  whatsappLabel,
  availableLabel,
  safetyNote,
}) => (
  <>
    {intro && (
      <div
        className="myka-v2-hero__intro"
        dangerouslySetInnerHTML={{ __html: intro }}
      />
    )}

    <div className="myka-v2-hero__cta-group">
      <button type="button" className="myka-v2-hero__cta open-chat-btn">
        {linkLabel || "Chat with Myka Now!"}
      </button>

      {whatsappUrl && (
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer"
          className="myka-v2-hero__whatsapp-btn"
        >
          <WhatsAppIcon />
          {whatsappLabel || "Chat with Myka on WhatsApp"}
        </a>
      )}
    </div>

    <div className="myka-v2-hero__social-section">
      {availableLabel && (
        <div
          className="myka-v2-hero__available-label"
          dangerouslySetInnerHTML={{ __html: availableLabel }}
        />
      )}

      {safetyNote && (
        <div
          className="myka-v2-hero__safety-note"
          dangerouslySetInnerHTML={{ __html: safetyNote }}
        />
      )}
    </div>
  </>
)

const MykaV2Hero = ({
  title,
  intro,
  linkLabel,
  imageUrl,
  imageAlt,
  availableLabel,
  whatsappUrl,
  whatsappLabel,
  safetyNote,
}) => {
  const bodyProps = { intro, linkLabel, whatsappUrl, whatsappLabel, availableLabel, safetyNote }

  return (
    <>
      <section className="myka-v2-hero">
        <img src={HeroBgVector} alt="" aria-hidden="true" className="myka-v2-hero__bg-vector" />
        <Container>
          <Row className="myka-v2-hero__row">
            <Col xs={12} lg={5} className="order-2 myka-v2-hero__illustration-col">
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt={imageAlt || ""}
                  className="myka-v2-hero__illustration"
                  loading="eager"
                />
              )}
            </Col>

            <Col xs={12} lg={7} className="order-1 myka-v2-hero__content">
              {title && (
                <h1
                  className="myka-v2-hero__heading"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              )}

              <div className="myka-v2-hero__lg-content">
                <HeroBodyContent {...bodyProps} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="myka-v2-hero__mobile-content">
        <Container>
          <HeroBodyContent {...bodyProps} />
        </Container>
      </div>
    </>
  )
}

export default MykaV2Hero
